import { apiSlice } from "./apiSlice";

const onboardingApi = apiSlice
  .enhanceEndpoints({ addTagTypes: ["Onboarding"] })
  .injectEndpoints({
    endpoints: builder => ({
      getOnboarding: builder.query({
        query: () => "/api_company/onboarding/",
        providesTags: ["Onboarding"],
      }),
      skipOnboardingStep: builder.mutation({
        query: stepKey => ({
          url: `/api_company/onboarding/steps/${encodeURIComponent(stepKey)}/skip/`,
          method: "POST",
        }),
        invalidatesTags: ["Onboarding"],
      }),
      unskipOnboardingStep: builder.mutation({
        query: stepKey => ({
          url: `/api_company/onboarding/steps/${encodeURIComponent(stepKey)}/unskip/`,
          method: "POST",
        }),
        invalidatesTags: ["Onboarding"],
      }),
      confirmOnboardingStep: builder.mutation({
        query: stepKey => ({
          url: `/api_company/onboarding/steps/${encodeURIComponent(stepKey)}/confirm/`,
          method: "POST",
        }),
        invalidatesTags: ["Onboarding"],
      }),
      updateOnboardingPreferences: builder.mutation({
        query: body => ({
          url: "/api_company/onboarding/preferences/",
          method: "PATCH",
          body,
        }),
        invalidatesTags: ["Onboarding"],
      }),
      markHintSeen: builder.mutation({
        query: hintKey => ({
          url: `/api_company/onboarding/hints/${encodeURIComponent(hintKey)}/seen/`,
          method: "POST",
        }),
        invalidatesTags: ["Onboarding"],
      }),
    }),
  });

export const {
  useGetOnboardingQuery,
  useSkipOnboardingStepMutation,
  useUnskipOnboardingStepMutation,
  useConfirmOnboardingStepMutation,
  useUpdateOnboardingPreferencesMutation,
  useMarkHintSeenMutation,
} = onboardingApi;
